import ExcelJS from "exceljs";

function safeFilePart(value, fallback = "form") {
  return String(value || fallback)
    .replace(/[^\w-]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 48);
}

function formatPerformedAt(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

/**
 * Export filtered e-Source form audit rows to Excel.
 * @param {Array} exportRows - flattened rows: { performedAt, action, version, field, oldValue, newValue, performedBy, reason }
 * @param {{ formLabel?: string }} options
 */
export async function exportEsourceAuditLogToExcel(
  exportRows = [],
  { formLabel = "form" } = {},
) {
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Audit Log");
  const headers = [
    "Performed At",
    "Action",
    "Version",
    "Field",
    "Old Value",
    "New Value",
    "Performed By",
    "Reason",
  ];

  const headerRow = ws.addRow(headers);
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF4472C4" },
    };
  });

  exportRows.forEach((row) => {
    ws.addRow([
      formatPerformedAt(row.performedAt),
      row.action || "",
      row.version || "",
      row.field || "",
      row.oldValue || "",
      row.newValue || "",
      row.performedBy || "",
      row.reason || "",
    ]);
  });

  ws.columns = [
    { width: 22 },
    { width: 24 },
    { width: 10 },
    { width: 16 },
    { width: 28 },
    { width: 28 },
    { width: 18 },
    { width: 28 },
  ];

  const buf = await wb.xlsx.writeBuffer();
  const blob = new Blob([buf], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `esource-audit-log-${safeFilePart(formLabel)}-${new Date()
    .toISOString()
    .slice(0, 10)}.xlsx`;
  link.click();
  URL.revokeObjectURL(url);
}
